"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _link = require("rich-text-lib/constants/link");

var _dom = require("../../utils/dom");

var _utils = require("../../utils");

var _image = require("../../utils/image");

var _withLinkCache = _interopRequireDefault(require("rich-text-lib/components/hoc/withLinkCache"));

var _shared = require("../../hslink/shared");

var _link2 = require("../../utils/link");

var _LinkEditPopover = _interopRequireDefault(require("../LinkEditPopover"));

var _LinkInsertPopover = _interopRequireDefault(require("../LinkInsertPopover"));

var LinkEditPopoverWithCache = (0, _withLinkCache.default)(_LinkEditPopover.default);
var LinkInsertPopoverWithCache = (0, _withLinkCache.default)(_LinkInsertPopover.default);
var popoverUniqueIndex = 0;

var LinkToolbarButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LinkToolbarButton, _Component);

  function LinkToolbarButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LinkToolbarButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LinkToolbarButton).call(this, props));
    _this.state = {
      editMode: _link.EditMode.PREVIEW,
      open: false,
      isActive: false,
      target: null,
      selectedText: '',
      mountedToText: false,
      type: 'insert'
    };
    _this.mounted = false;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRemove = _this.handleRemove.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleNodeChange = _this.handleNodeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.initTargetAndSelection = _this.initTargetAndSelection.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderEditMode = _this.renderEditMode.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderInsertMode = _this.renderInsertMode.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LinkToolbarButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          editor = _this$props.editor,
          keyboardShortcutEvent = _this$props.keyboardShortcutEvent;
      editor.on(keyboardShortcutEvent, this.handleClick);
      editor.on('NodeChange', this.handleNodeChange);
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          editor = _this$props2.editor,
          keyboardShortcutEvent = _this$props2.keyboardShortcutEvent;
      editor.off(keyboardShortcutEvent, this.handleClick);
      editor.off('NodeChange', this.handleNodeChange);
      this.mounted = false;
    }
  }, {
    key: "initTargetAndSelection",
    value: function initTargetAndSelection() {
      var editor = this.props.editor;
      var selectionContent = editor.selection.getContent();

      if (!(0, _utils.isWhitespace)(selectionContent)) {
        editor.formatter.apply('link', {
          href: null,
          'data-insert': true
        });
        this.setState({
          selectedText: selectionContent,
          target: editor.selection.getSel().anchorNode.parentNode,
          mountedToText: true
        });
      } else {
        this.setState({
          selectedText: '',
          target: null,
          mountedToText: false
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var editor = this.props.editor;
      var _this$state = this.state,
          open = _this$state.open,
          type = _this$state.type,
          editMode = _this$state.editMode;
      var selectedNode = editor.selection.getNode();

      if ((0, _image.imageIsOnlyChild)(editor, selectedNode)) {
        var element = selectedNode.nodeName === 'IMG' ? selectedNode : selectedNode.querySelector('img');
        editor.fire('InsertLinkOnImage', {
          element: element
        });
        return;
      }

      if (type === 'edit') {
        this.setState({
          editMode: editMode === _link.EditMode.EDIT ? _link.EditMode.PREVIEW : _link.EditMode.EDIT
        });
        return;
      }

      if (!open) this.initTargetAndSelection();
      this.setState({
        open: !open,
        isActive: !open
      });
      popoverUniqueIndex++;
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      if (this.mounted && (this.state.open || this.state.isActive)) {
        this.setState({
          open: false,
          isActive: false,
          editMode: _link.EditMode.PREVIEW
        });
      }
    }
  }, {
    key: "handleNodeChange",
    value: function handleNodeChange(e) {
      var editor = this.props.editor;
      var _this$state2 = this.state,
          open = _this$state2.open,
          target = _this$state2.target,
          editMode = _this$state2.editMode;
      var isNodeWithinLink = (0, _dom.isElementOrChildOf)(e.element, target);

      if (open && target && (!isNodeWithinLink || isNodeWithinLink && e.element.nodeName === 'IMG')) {
        this.handleRemove();
        return;
      }

      if (!(0, _link2.selectionIsWithinLink)(editor)) {
        this.setState({
          type: 'insert',
          editMode: _link.EditMode.PREVIEW,
          isActive: false
        });
        return;
      }

      if ((0, _image.imageIsOnlyChild)(editor, editor.selection.getNode())) {
        this.setState({
          isActive: true
        });
        return;
      }

      var $selection = editor.$(editor.selection.getNode());
      var $selectedLink = (0, _link2.getSelectedLink)($selection);
      var $popoverTarget = (0, _shared.getPopoverTarget)($selectedLink);

      if (this.state.target !== $popoverTarget[0]) {
        popoverUniqueIndex++;
      }

      this.setState({
        type: 'edit',
        target: $popoverTarget[0],
        $selectedLink: $selectedLink,
        editMode: editMode,
        open: true,
        isActive: true
      });
    }
  }, {
    key: "renderEditMode",
    value: function renderEditMode() {
      var _this2 = this;

      var _this$props3 = this.props,
          editor = _this$props3.editor,
          onChangeLink = _this$props3.onChangeLink,
          onSelectFile = _this$props3.onSelectFile,
          fetchPages = _this$props3.fetchPages,
          fetchMeetings = _this$props3.fetchMeetings,
          fetchAnchors = _this$props3.fetchAnchors,
          fetchMeetingBySlug = _this$props3.fetchMeetingBySlug,
          showRefAndTargetControls = _this$props3.showRefAndTargetControls,
          useEmailSubscription = _this$props3.useEmailSubscription,
          fetchPageBySlug = _this$props3.fetchPageBySlug,
          fetchFileFromUrl = _this$props3.fetchFileFromUrl,
          allowFileDownload = _this$props3.allowFileDownload,
          allowMeetingLink = _this$props3.allowMeetingLink,
          allowAnchorLinks = _this$props3.allowAnchorLinks;
      var _this$state3 = this.state,
          open = _this$state3.open,
          target = _this$state3.target,
          type = _this$state3.type,
          editMode = _this$state3.editMode,
          $selectedLink = _this$state3.$selectedLink;
      return _react.default.createElement(LinkEditPopoverWithCache, (0, _extends2.default)({
        type: type,
        editor: editor,
        open: open,
        target: target,
        onRemove: this.handleRemove,
        fetchPages: fetchPages,
        fetchMeetings: fetchMeetings,
        fetchAnchors: fetchAnchors,
        fetchMeetingBySlug: fetchMeetingBySlug,
        onSelectFile: onSelectFile,
        showRefAndTargetControls: showRefAndTargetControls,
        useEmailSubscription: useEmailSubscription,
        allowFileDownload: allowFileDownload,
        allowMeetingLink: allowMeetingLink,
        allowAnchorLinks: allowAnchorLinks,
        mode: editMode,
        updateMode: function updateMode(mode) {
          return _this2.setState({
            editMode: mode
          });
        },
        fetchPageBySlug: fetchPageBySlug,
        fetchFileFromUrl: fetchFileFromUrl,
        onUnlink: (0, _shared.getUnlinkHandler)(editor),
        onUpdate: onChangeLink,
        onAnchorPreviewClick: (0, _shared.getAnchorPreviewClickHandler)(editor),
        onClose: function onClose() {
          return editor.focus();
        },
        key: popoverUniqueIndex // base link prop logic (href, external, nofollow) isn't component specific so pull in from util

      }, (0, _link2.getLinkAttrProps)(editor, $selectedLink)), this.props.renderButton(this.handleClick, this.state.isActive, this.state.type));
    }
  }, {
    key: "renderInsertMode",
    value: function renderInsertMode() {
      var _this$props4 = this.props,
          editor = _this$props4.editor,
          onSelectFile = _this$props4.onSelectFile,
          onChangeLink = _this$props4.onChangeLink,
          fetchPages = _this$props4.fetchPages,
          fetchMeetings = _this$props4.fetchMeetings,
          fetchAnchors = _this$props4.fetchAnchors,
          showRefAndTargetControls = _this$props4.showRefAndTargetControls,
          useEmailSubscription = _this$props4.useEmailSubscription,
          allowFileDownload = _this$props4.allowFileDownload,
          allowMeetingLink = _this$props4.allowMeetingLink,
          allowAnchorLinks = _this$props4.allowAnchorLinks,
          removeUnInsertedLinks = _this$props4.removeUnInsertedLinks;
      var _this$state4 = this.state,
          open = _this$state4.open,
          target = _this$state4.target,
          selectedText = _this$state4.selectedText,
          mountedToText = _this$state4.mountedToText,
          type = _this$state4.type;
      return _react.default.createElement(LinkInsertPopoverWithCache, {
        type: type,
        editor: editor,
        open: open,
        target: target,
        onRemove: this.handleRemove,
        fetchPages: fetchPages,
        fetchMeetings: fetchMeetings,
        fetchAnchors: fetchAnchors,
        onSelectFile: onSelectFile,
        showRefAndTargetControls: showRefAndTargetControls,
        useEmailSubscription: useEmailSubscription,
        allowFileDownload: allowFileDownload,
        allowMeetingLink: allowMeetingLink,
        allowAnchorLinks: allowAnchorLinks,
        selectedText: selectedText,
        mountedToText: mountedToText,
        onInsert: onChangeLink,
        removeUnInsertedLinks: removeUnInsertedLinks
      }, this.props.renderButton(this.handleClick, this.state.isActive, this.state.type));
    }
  }, {
    key: "render",
    value: function render() {
      var type = this.state.type;
      return type === 'insert' ? this.renderInsertMode() : this.renderEditMode();
    }
  }]);
  return LinkToolbarButton;
}(_react.Component);

exports.default = LinkToolbarButton;
LinkToolbarButton.propTypes = {
  editor: _react.PropTypes.object.isRequired,
  removeUnInsertedLinks: _react.PropTypes.func.isRequired,
  onSelectFile: _react.PropTypes.func.isRequired,
  onChangeLink: _react.PropTypes.func.isRequired,
  fetchPages: _react.PropTypes.func.isRequired,
  fetchMeetings: _react.PropTypes.func.isRequired,
  fetchAnchors: _react.PropTypes.func.isRequired,
  fetchMeetingBySlug: _react.PropTypes.func.isRequired,
  showRefAndTargetControls: _react.PropTypes.bool.isRequired,
  useEmailSubscription: _react.PropTypes.bool.isRequired,
  keyboardShortcutEvent: _react.PropTypes.string.isRequired,
  fetchPageBySlug: _react.PropTypes.func.isRequired,
  fetchFileFromUrl: _react.PropTypes.func.isRequired,
  renderButton: _react.PropTypes.func.isRequired,
  allowFileDownload: _react.PropTypes.bool,
  allowMeetingLink: _react.PropTypes.bool,
  allowAnchorLinks: _react.PropTypes.bool
};
module.exports = exports.default;